export default "__VITE_ASSET__X39BKjuP__"